<template>
    <div  class="agendamento modal-2" v-if='getModalSchedule || false'>
		<div class="modal-content">
			<div class="modal-head">
				<h3 class="title-text">Agendamento</h3>
				<span @click='btnClose' class='closeBtn'>&times;</span>
			</div>

			<div class="tmp-modal-content">
				<label>Nome: </label>
				<div class="icon-input">
					<i class="fas fa-user" style="color: #1C869A"></i>
					<input type="text" :class="['title', {'editable': editable}]" v-model="name" :disabled="!editable"/>
				</div>

				<label>Data: </label>
				<div class="icon-input">
					<i class="fas fa-calendar-alt" style="color: #f77f00"></i>
					<input type="datetime-local" :class="['date', {'editable': editable}]" v-model="today" :disabled="!editable"/>
				</div>

				<div class="contatos">
					<label>Telefone 1: </label>
					<div class="button-none" @click="callNum(phone_one)">
						<i class="fas fa-phone"></i>
						<span for="phone_one" class="ligar-agora">Ligar</span>
						<input 
                            name="phone_one" 
                            id="phone_one" 
                            type="text" 
                            :class="['phone', {'centralize-phone': !phone_two}, {'editable': editable}]" 
                            v-model="phone_one"
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            :disabled="!editable"
                        />
					</div>

					<label>Telefone 2: </label>
					<div class="button-none" @click="callNum(phone_two)">
						<i class="fas fa-phone" for="num_two"></i>
						<span for="phone_two" class="ligar-agora">Ligar</span>
						<input 
                            name="num_two" 
                            id="num_two" 
                            type="text" 
                            :class="['phone', {'editable': editable}]" 
                            v-mask="['(##) ####-####', '(##) #####-####']"
                            v-model="phone_two" 
                            :disabled="!editable"
                        />
					</div>
				</div>

				<label>Descrição: </label>
				<textarea :class="['notes', {'editable': editable}]" rows="4" cols="50"  v-model="note" :disabled="!editable"></textarea>
			</div>

			<div class="modal-footer">
				<div v-if="!editable">
					<!-- <button class="verde" @click="callNum(phone_one)"> <i class="fas fa-phone"></i> Ligar</button> -->
					<button class="azul" @click="toggleEdit()"> <i class="fas fa-edit"></i> Editar</button>
					<button class="vermelho" @click="deleteSch(id)"> <i class="fas fa-trash-alt"></i> Excluir</button>
				</div>

				<div v-else>
					<button class="verde" @click="updateClient(id)"> <i class="fas fa-save"></i> Salvar</button>
					<button class="vermelho" @click="toggleEdit()"> <i class="fas fa-times-circle"></i> Cancelar</button>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import swal from 'sweetalert';
// window.realtime = io.connect("http://localhost" + ":3002/"); //CONEXÃO LOCAL
window.realtime = io.connect("https://" + location.hostname + ":3002/");
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Date.prototype.GMTZAO= function() {
      return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        '.' + (this.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        'Z';
}

function pad(number) {
    if (number < 10) {
        return '0' + number;
    }

    return number;
}

export default {
    data() {
        return {
            id: '',
            name: '',
            today: '', //'2018-06-12T19:30:00'
            phone_one: '',
            phone_two: '',
            note: '',
            editable: false,
        }
    },
    watch: {
        getModalSchedule: function() {
	        if(this.getModalSchedule) return;

            this.id = '';
            this.name = '';
            this.today = '';
            this.phone_one = '';
            this.phone_two = '';
            this.note = '';
            this.editable = false;
	        this.setClientToModal(false);
        },

        getClientToModal: function() {
        	if(!this.getClientToModal) return;

	    	this.name = this.getClientToModal.client_name;
            this.today = new Date(`${this.getClientToModal.start_date} GMT-3`).GMTZAO().split('.')[0];
            // this.today = new Date().toISOString().split('.')[0];

	    	this.phone_one = this.getClientToModal.phone_one
            this.phone_two = this.getClientToModal.phone_two

            this.note = this.getClientToModal.observation;
            this.id = this.getClientToModal.id;
        },

        getEditable: function() {
            this.editable = true;

            this.today = new Date(this.getHour).GMTZAO().split('.')[0];
        }

    },
    computed:{
        ...mapGetters(['getModalSchedule', 'getClientToModal', 'getHour','getEditable'])
    },

    methods:{
        ...mapActions(['setModalSchedule', 'remoteUpdateCalendar', 'setClientToModal']),

        btnClose(event){
            this.setModalSchedule();
        },

        toggleEdit(){
            this.editable = !this.editable;
	        if(this.id == '') this.btnClose();
        },
        callNum(tel){
            if(this.editable) return;
			if(!tel) return;

			realtime.emit('Originate', {
				calltype: 'outgoing',
				extension: user.getExtension(),
				phone: '0' + tel.replace(/\D+/g, '')
			});
        },
        deleteSch(id){
			swal({
				title: "Tem certeza que deseja excluir agendamento?",
				text: "Você não poderá restaurar esse agendamento novamente!",
				icon: "warning",
				buttons: {
					cancel: 'Cancelar',
					confirm: {
						text: 'Sim, excluir',
						value: true,
						visible: true,
						className: 'vermelho-global'
					},
				},

			}).then(confirmOpt=> {
				if(!confirmOpt) return;
				console.log("Excluir: ", confirmOpt);
				fetch(`delete-scheduling?id=${this.id}`).then(data => {
					this.feedback_calendar('Agendamento exluido');
					this.remoteUpdateCalendar();
				});
			});
        },
        updateClient(id){
            this.phone_one = (!this.phone_one) ? '' : this.phone_one;
            this.phone_two = (!this.phone_two) ? '' : this.phone_two;

            // Create
            if(!this.id){

                let params = `client_name=${this.name}&phone_one=${this.phone_one.replace(/\D+/g, '')}&phone_two=${this.phone_two.replace(/\D+/g, '')}&observation=${this.note}&start_date=${this.today}`
                console.log(params);
                fetch(`create-scheduling?${params}`).then(data =>{
                    this.feedback_calendar('Agendamento criado');
                    this.remoteUpdateCalendar();
                });

            } else { // update

                let params = `id=${this.id}&client_name=${this.name}&phone_one=${this.phone_one.replace(/\D+/g, '')}&phone_two=${this.phone_two.replace(/\D+/g, '')}&observation=${this.note}&start_date=${this.today}`
                fetch(`update-scheduling?${params}`).then(data => {
                    this.feedback_calendar('Agendamento atualizado');
                    this.remoteUpdateCalendar();
                });
            }

        },
		feedback_calendar(msg){
            this.btnClose();
			swal({icon: 'success', text: msg})
		},
        doFormat(x, pattern, mask) {
            if(!x) return;
            var strippedValue = x.replace(/[^0-9]/g, "");
            var chars = strippedValue.split('');
            var count = 0;

            var formatted = '';
            for (var i=0; i<pattern.length; i++) {
                const c = pattern[i];
                if (chars[count]) {
                if (/\*/.test(c)) {
                    formatted += chars[count];
                    count++;
                } else {
                    formatted += c;
                }
                } else if (mask) {
                if (mask.split('')[i])
                    formatted += mask.split('')[i];
                }
            }
            return formatted;
        }
    },
}
</script>

<style>
	.vermelho-global{
	 	background-color: #ef233c;
	 }

	.vermelho-global:hover{
	 	background-color: #ef233c !important;
		color: white;
    		box-shadow: 1px 1px 2px grey;
	}


</style>

<style scoped>
    .ligar-agora {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FAFAFA;
        color: #FAFAFA;
        font-weight: 600;
        padding: 10px;
        position: absolute;
        left: 32px;
        height: 3.5em;
    }

    .button-none:hover .ligar-agora {
        background-color: green;
        left: 5.6em;
        transition: 0.8s;
    }

	.tmp-modal-content label {
		font-size: 1em;
		font-weight: 600;
	}

	.tmp-modal-content input:focus , .tmp-modal-content textarea:focus{
		outline-width: 20px;
		outline-color: #1c859ac4;
	}

	.icon-input {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 1em;
	}

	.icon-input i{
		font-size: 1.8em;
		padding: 0.5em;
		border: none;
		background-color: lightgray;
		border-radius: 0.25em 0 0 0.25em !important;
	}

    .title{
        width: 90%;
        text-align: center;
        font-size: 2em;
        font-weight: unset;
		padding-left: 10px;
        background: none;
        border: none;
		border-radius: 0px 5px 5px 0px;
    }

    .date{
		font-size: 2em;
        width: 90%;
		padding-right: 0.2em;
		padding-left: 3em;
        text-align: center;
        border:none;
        background: none;
    }

    .contatos{
        display: flex;
		flex-direction: column;
        margin-top: 0.5em;
    }

    .contatos i{
        font-size: 1.8em;
        align-content: center;
        /* margin-top: 0.3em; */
        color: green;
		background-color: lightgray;
        cursor: pointer;
        padding:0.5em;
		border-radius: 0.25em 0 0 0.25em !important;
        z-index: 1;
    }

    .phone{
        width: 90%;
        font-size: 2em;
        cursor: pointer;
        text-align: center;
        border: none;
        background: none;
    }

    .button-none{
        cursor: pointer;
        display: flex;
		margin-bottom: 1.5em;
    }

    .notes{
		font-size: 1.2em;
        width: 100%;
        border: none;
        background: none;
        margin-bottom: 1em;
    }

    .modal-content{
        position: relative;
        margin: 10% auto;
        padding: 30px;
        max-width: 600px;
        border-radius: 4px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
        background-color: #FAFAFA;

    }

    .modal-footer button{
        border-radius: 0.25em !important;
        border: none;
        padding: 0.5em;
        color: white;
    }

    .modal-footer button:hover{
        /* background-color: transparent; */
        color: white;
		box-shadow: 1px 1px 2px gray;
    }

    .closeBtn{
        color: #000000;
        font-size: 24px;
        cursor: pointer;
    }

    .modal-head{
		position: relative;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 2rem;
		border-bottom: 1px solid #c4c2c2;
    }

    .verde{ background-color: green; }
    .azul{ background-color: #118ab2; }
    .vermelho{ background-color: #ef233c; }

    .modal-footer{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        padding: 0.75rem;
        border-top: 1px solid #dee2e6;
        border-bottom-right-radius: calc(0.3rem - 1px);
        border-bottom-left-radius: calc(0.3rem - 1px);
    }

    .editable{
        border-bottom: solid;
        border-color: lightgray;
        background: #e4e8ed;
        border-radius: 0 0.25em 0.25em 0 !important;
        z-index: 1;
    }

    .modal-2{
 
 z-index: 2;
 
 }
 
 .btn-outline-success {
 
 width: 100%;
 
 }
 
 .parcelas_instalacao-grupo{
 
 border: solid 1px;
 border-radius: 7px;
 border-color: #1c869a;
 
 }
 
 .header-taxa{
 
 text-align: center;
 font-size: 16px;
 
 }
 
 .ponto-adicional-grupo{
 
 border: solid 1px;
 border-radius: 7px;
 border-color: #1c869a;
 
 }
 
 .modal-content-my {
 
 position: relative;
 margin: 10% auto;
 padding: 30px;
 max-width: 81em;
 border-radius: 4px;
 box-shadow: 0 2px 10px rgb(0 0 0 / 16%);
 background-color: #FAFAFA;
 
 }
 
 .modal-2 {
 
 position: fixed;
 z-index: 1;
 left: 0;
 top: 0;
 height: 100%;
 width: 100%;
 overflow: auto;
 transition: all 0.5s ease;
 background-color: rgba(128, 128, 128, 0.418);
 
 }
 
 .closeBtn{
 
 color: #000000;
 font-size: 24px;
 cursor: pointer;
 
 }
 
 .modal-header {
 display: flex;
 align-items: flex-start;
 justify-content: space-between;
 padding: 1rem 1rem;
 border-bottom: 1px solid #dee2e6;
 border-top-left-radius: calc(0.3rem - 1px);
 border-top-right-radius: calc(0.3rem - 1px);
 }
</style>
